/**
 * File: AslTextController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class AslTextController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, $timeout,CONSTANTS,CQuesConst,Upload) {
    var MQ = MathQuill.getInterface(2);
    let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
    let userId = localStorageService.get("user_id")
    let USER_PATH = userId + "/asl/"
    let schoolId = localStorageService.get("school_id")
    let ASL_ANS_TYPE=CQuesConst.ASL_ANS_TYPE
    let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
    let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
    let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
    let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
    let SAVE_URL = CQuesConst.API_CREATE_DRAW  
    $scope.question;

    $scope.answer;

    $scope.errors = {};

    $scope.index;
      //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "Archives"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            $scope.index = this.index
            $scope.isLatex = false
            $scope.quesId = "text-question" + $scope.index;
            $scope.ansId = 'text-answer' + $scope.index;
            if ($scope.$parent.editQuestions[$scope.index]) {
              let currentQuestion = $scope.$parent.editQuestions[$scope.index]
              if (currentQuestion) {
                $scope.question = currentQuestion.qn_desc;
                $scope.isLatex = currentQuestion.isLatex;
                $scope.answer = currentQuestion.answer
              }
            }
        }
        //On destroy function
        this.$onDestroy = () => {
        }
        
          $timeout(() => {
            var MQ = MathQuill.getInterface(2);
            var textQuestion = document.getElementById("text-question" + $scope.index);
            textQuestion.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
            if ($scope.question !== undefined) {
              textQuestion.textContent = $scope.question
            }
            var mathField = MQ.MathField(textQuestion, {
              spaceBehavesLikeTab: false,
              restrictMismatchedBrackets: true,
              handlers: {
                edit: function() {
                  $scope.question = mathField.latex()
                }
              }
            });
            var textAnswer = document.getElementById('text-answer' + $scope.index);
            textAnswer.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
            if ($scope.answer !== undefined) {
              textAnswer.textContent = $scope.answer
            }
            var mathFieldAnswer = MQ.MathField(textAnswer, {
              spaceBehavesLikeTab: false,
              restrictMismatchedBrackets: true,
              handlers: {
                edit: function() {
                  $scope.answer = mathFieldAnswer.latex()
                }
              }
            });
          }, 10)
      
          /*
           * Function to add to list
           *
           * @return : null
           */
          $scope.addToList = () => {
            $scope.errors = {}
            let errCount = 0;
            if ($scope.question === undefined || $scope.question === "") {
              $scope.errors.question = "Please Enter Question"
              errCount++;
            }else if($scope.question.length>500){
              $scope.errors.question="Question does not exceed 500 characters";
              errCount++;
            }
            if ($scope.answer === undefined || $scope.answer === "") {
              $scope.errors.answer = "Please Enter Answer"
              errCount++;
            }else if($scope.answer.length>500){
              $scope.errors.answer="Answer does not exceed 500 characters";
              errCount++;
            }
            if (errCount == 0) {
              let obj = {
                type: ASL_ANS_TYPE.TEXT,
                qn_desc: $scope.question,
                isLatex: $scope.isLatex,
                answer: $scope.answer
              }
              $scope.question = "";
              $scope.answer = "";
              $scope.isLatex = false;
              $scope.$parent.addToList(obj, $scope.index)
            }
          }

    }
}

export default AslTextController;


// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/aslTextController.js